// Export all data from separate files
export { services } from './services';
export { industries } from './industries';
export { useCases } from './use-cases';
export { blogs } from './blogs';
export { 
  navLinks, 
  testimonials, 
  footerLinks, 
  socialLinks, 
  valuesData 
} from './navigation';

// Re-export types
export type { Service } from './services';
export type { Industry } from './industries';
export type { UseCase } from './use-cases';
export type { NavLink, Testimonial, FooterLinkSection, SocialLink } from './navigation'; 